/**
 * Created by venbommineni on 3/17/2017.
 */
import CommonApp from '../../app.js';

var PageLevelMsgService = function($http, $q, $window) {
    this.$http = $http;
    this.setEmailFlagGigya = function(gigyaId) {
        var config = {
            headers: {
                'content-type': 'application/json',
                'showgloballoader': true
            }
        };
        var reqData = {
            UID: gigyaId
        };

        var defferedSetUserName = $q.defer();
        $http.post($window.location.protocol+'//'+$window.location.host
            + '/mecommerce/signup/user/setEmailVerificationFlag', reqData, config ).then(function(response) {
            defferedSetUserName.resolve(response.data);
        });
        return defferedSetUserName.promise;
    };
};

PageLevelMsgService.$inject = ['$http', '$q', '$window'];
CommonApp.module.service('pageLevelMsgService', PageLevelMsgService);




//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/components/page-level-messages/service.js
// module id = 249
// module chunks = 0